import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isProfileIncomplete } from '../../utils/invoiceProfile';
import { COLORS } from '../../styles/tokens';

// Kompakt, ikke-blokkerende banner øverst i sjåførkartet så lenge utbetaling og fakturering mangler.
// Vises ikke for andre enn sjåfører (og ikke når en admin ser appen som en annen rolle).
export default function ProfileIncompleteBanner() {
  const { userDoc, viewingAs } = useAuth();
  const isDriver = Array.isArray(userDoc?.roles) && userDoc.roles.includes('driver');
  // Sjåfører i et transportfirma får betalt via firmaet og trenger ikke egne fakturaopplysninger
  if (!userDoc || viewingAs || !isDriver || userDoc.carrierOrgId || !isProfileIncomplete(userDoc)) return null;

  return (
    <div role="status" style={styles.bar}>
      <span style={styles.text}>Fullfør utbetaling og fakturering for å kunne ta oppdrag</span>
      <Link to="/driver/profil#faktura" className="tippi-btn" style={styles.btn}>Fyll ut</Link>
    </div>
  );
}

const styles = {
  bar:  { display: 'flex', alignItems: 'center', gap: 10, padding: '8px 14px', background: COLORS.warningBg, borderBottom: `1px solid ${COLORS.warningBorder}`, color: COLORS.warningText, flexShrink: 0 },
  text: { flex: 1, fontSize: 13, fontWeight: 600, lineHeight: 1.35 },
  btn:  { flexShrink: 0, padding: '6px 14px', borderRadius: 16, background: COLORS.accent, color: '#1a1a2e', fontSize: 13, fontWeight: 700, textDecoration: 'none' },
};
